import api from '@/api';
import {
  ImportDigitalCertificateRequest,
  InvoiceSettinsCertificate,
  InvoiceSettinsCertificates,
} from './Certificate.types';
import { API_BASE_URL } from '..';

const CONTROLLER_URL_CERTIFICATE = `${API_BASE_URL}/certificate`;

export async function uploadInvoiceSettingsCertificate({
  isEdit,
  ...obj
}: ImportDigitalCertificateRequest & { isEdit: boolean }) {
  const { ...values } = obj;

  const formData = new FormData();

  for (const key in values) {
    formData.append(key, values[key as keyof typeof values]);
  }

  const action = isEdit ? api.put : api.post;

  const result = (await action(
    `${CONTROLLER_URL_CERTIFICATE}`,
    formData,
    null,
    { contentType: 'multpart/form-data' },
  )) as unknown;

  return result as void;
}

//

export async function getInvoiceSettingsCertificates() {
  const result = (await api.get(
    `${CONTROLLER_URL_CERTIFICATE}`,
    null,
  )) as unknown;

  return result as InvoiceSettinsCertificates[];
}

export async function getInvoiceSettingsCertificateId(companyId: number) {
  const result = (await api.get(`${CONTROLLER_URL_CERTIFICATE}`, {
    companyId,
  })) as unknown;

  return result as InvoiceSettinsCertificate;
}

export async function deleteCertificate(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL_CERTIFICATE}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
